exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.col1 {\n  background-color: #4D342E;\n}\n.field-survey-table-disabled-row TD {\n  background-color: #d9d9d9;\n}\n.field-survey-table-disabled-row TD:first-of-type {\n  background-color: white!important;\n}\n.field-survey-table-disabled-row TD:nth-of-type(2) {\n  background-color: white!important;\n}\n\n", ""]);

// exports
